import React from 'react'

function PlayerSource() {
  
  if (document.getElementById(`player-source`) !== null) {
    let activeSong = document.getElementById(`song-title`)
    
    activeSong.addEventListener(`loadedmetadata`, function() {
      updateTime()
    })
  }
  
  function updateTime() {
    let activeSong = document.getElementById(`player-source`)
    
    var currentSeconds = (Math.floor(activeSong.currentTime % 60) < 10 ? `0` : ``) + Math.floor(activeSong.currentTime % 60)
    var currentMinutes = Math.floor(activeSong.currentTime / 60)
    
    //Sets the current song location compared to the song duration.
    document.getElementById(`song-time`).innerHTML = currentMinutes + `:` + currentSeconds + ` / ` + Math.floor(activeSong.duration / 60) + `:` + (Math.floor(activeSong.duration % 60) < 10 ? `0` : ``) + Math.floor(activeSong.duration % 60)
    
    //Fills out the slider with the appropriate position.
    var percentageOfSong = (activeSong.currentTime/activeSong.duration)
    var percentageOfSlider = document.getElementById(`song-slider`).offsetWidth * percentageOfSong
    
    //Updates the track progress div.
    document.getElementById(`track-progress`).style.width = Math.round(percentageOfSlider) + `px`
  }
  
  return (
    <audio id={`player-source`} onTimeUpdate={updateTime} src={""} preload="metadata">Your browser does not support the audio tag.</audio>
  )
}

export default PlayerSource